// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataFieldItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';

import ReportDesignerWidget from 'share/components/hoc/Izenda.ReportDesignerWidget';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import LayoutUtils from 'share/utils/Izenda.LayoutUtils';

/**
 * FieldItem component
 */
const DataFieldItem = observer(props => {
  const {itemData: field, className , store, isRegistedItem} = props;
  const classes = classnames('fieldItem u_curPointer', className, {
    'registed-prop-editor': isRegistedItem
  });

  return (
    <div className={classes} onMouseDown={props.onClick} onClick={showPropertiesEditor}>
      <OverflowText text={field.name} tooltip={field.izendaDataType}>
        <i className={store.dataTree.getIcon(field.izendaDataType)} />
        <TextHighLight highlight={props.filterText} text={field.name} tooltip={field.name} />
      </OverflowText>
      {props.isCalculated && <div title="Delete" className="icon-cancel pull-right" onClick={clickDelete} />}
    </div>
  );

  function showPropertiesEditor() {
    LayoutUtils.togglePropertiesEditor(true);
  }

  function clickDelete(e) {
    props.clickDelete(field);
  }
});

DataFieldItem.displayName = 'DataFieldItem';

export default ReportDesignerWidget.wrapper(DataFieldItem);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataFieldItem.js